module.exports = __webpack_public_path__ + "static/media/SN.261060c9.svg";